/* this file is generated by grunt when calling `npm run build -- --plugins=<plugins> */
import TomSelect from "./tom-select";
import dropdown_header from './plugins/dropdown_header/plugin.js';
TomSelect.define('dropdown_header', dropdown_header);
export default TomSelect;